import React from "react";

export default function EasterFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".clse1-1{fill:#f7eed1}.clse1-2{fill:#f2b39f}.clse1-3{fill:#6d3f35}.clse1-5{fill:#eadcb7}"
            }
          </style>
        </defs>
        <path
          className="clse1-1"
          d="M869.46 194.15c64.53 18.32 159.63 421.5 92.87 437.57-66.42 16-219.93-368.86-176.47-415.51a87.72 87.72 0 0 1 39-23.92 96.19 96.19 0 0 1 44.6 1.86Z"
        />
        <path
          className="clse1-2"
          d="M852.29 237c38.37 19 119.87 348.57 82.49 357-37.18 8.42-151.1-310.37-129.17-344.89 8.76-13.79 20.9-16.59 20.9-16.59s11.49-2.61 25.78 4.48Z"
        />
        <path
          className="clse1-1"
          d="M1134.34 194.15c-64.52 18.32-159.63 421.5-92.87 437.57 66.42 16 219.93-368.86 176.47-415.51a87.67 87.67 0 0 0-39-23.92 96.18 96.18 0 0 0-44.6 1.86Z"
        />
        <path
          className="clse1-2"
          d="M1149.93 237c-38.37 19-119.87 348.57-82.5 357 37.19 8.42 151.1-310.37 129.17-344.89-8.76-13.79-20.89-16.59-20.89-16.59s-11.46-2.61-25.78 4.48Z"
        />
        <path
          className="clse1-1"
          d="M1232.66 822.67c5.8-10.26 26-46.07 24.33-89.85-2.72-71-55.42-116.54-70.92-129.93-71.22-61.55-161.06-59.4-195-58.58-36.18.87-102.38 2.45-162.28 48.22-14.74 11.25-77.49 59.19-81.83 140.29-.61 11.08-2.96 67.18 37.2 115.93a155.5 155.5 0 0 0 18.71 19l390.94 3.38a196.84 196.84 0 0 0 38.85-48.46Z"
        />
        <ellipse
          className="clse1-3"
          cx={901.65}
          cy={723.05}
          rx={17.69}
          ry={23.38}
        />
        <ellipse
          className="clse1-3"
          cx={1102.15}
          cy={723.05}
          rx={17.69}
          ry={23.38}
        />
        <path
          className="clse1-2"
          d="M1034.18 766.58c0 9.68-14.45 24.41-32.28 24.41s-32.27-14.73-32.27-24.41 14.45-8.52 32.27-8.52 32.28-1.17 32.28 8.52Z"
        />
        <path
          d="M1360.37 1704.17H639.63a69.18 69.18 0 0 1-69.1-69.1V914.34a69.18 69.18 0 0 1 69.1-69.1h720.74a69.18 69.18 0 0 1 69.1 69.1v720.73a69.18 69.18 0 0 1-69.1 69.1ZM639.63 889.24a25.13 25.13 0 0 0-25.1 25.1v720.73a25.13 25.13 0 0 0 25.1 25.1h720.74a25.13 25.13 0 0 0 25.1-25.1V914.34a25.13 25.13 0 0 0-25.1-25.1Z"
          style={{
            fill: "#ffab9e",
          }}
        />
        <ellipse
          className="clse1-2"
          cx={1182.04}
          cy={779.37}
          rx={52.21}
          ry={29.16}
        />
        <ellipse
          className="clse1-2"
          cx={820.02}
          cy={779.37}
          rx={52.21}
          ry={29.16}
        />
        <path
          className="clse1-3"
          d="M824.3 781.31a2.93 2.93 0 0 1-1.11-.22L695.33 730a3 3 0 0 1 2.22-5.57l127.87 51.12a3 3 0 0 1-1.12 5.79ZM751.57 853.83a3 3 0 0 1-1.89-5.33l72.74-58.81a3 3 0 0 1 3.77 4.67l-72.74 58.8a3 3 0 0 1-1.88.67ZM1179.5 782.13a3 3 0 0 1-1.12-5.79l127.87-51.12a3 3 0 1 1 2.22 5.57l-127.86 51.13a3.08 3.08 0 0 1-1.11.21ZM1252.24 854.66a3 3 0 0 1-1.89-.67l-72.74-58.81a3 3 0 1 1 3.77-4.66l72.74 58.8a3 3 0 0 1-1.88 5.34Z"
        />
        <ellipse
          className="clse1-5"
          cx={774.25}
          cy={862.87}
          rx={69.54}
          ry={41.45}
        />
        <ellipse
          className="clse1-5"
          cx={1230.2}
          cy={862.87}
          rx={69.54}
          ry={41.45}
        />
        <path
          className="clse1-1"
          d="M1194.75 1659.76c-4.36 28-20.53 129.48-80.44 147.09-29 8.51-61.24-4.6-80.77-27.72-44.86-53.1-13.93-149-6.15-173.07 23.46-72.68 83.79-159.53 126.64-145.78 44.5 14.27 51.81 128.3 40.72 199.48Z"
        />
        <path
          className="clse1-2"
          d="M1163.08 1649.33c-3.62 21.21-17 98.14-55.27 114-18.5 7.65-38.43-.8-50-17.31-26.59-37.94-4.1-111.27 1.56-129.72 17.05-55.6 57.77-123.44 84.33-115 27.57 8.78 28.6 94.09 19.38 148.03Z"
        />
        <path
          className="clse1-1"
          d="M808.94 1659.76c4.36 28 20.52 129.48 80.44 147.09 29 8.51 61.24-4.6 80.77-27.72 44.86-53.1 13.92-149 6.14-173.07-23.45-72.68-83.78-159.53-126.64-145.78-44.49 14.27-51.8 128.3-40.71 199.48Z"
        />
        <path
          className="clse1-2"
          d="M840.6 1649.33c3.63 21.21 17 98.14 55.28 114 18.5 7.65 38.42-.8 50-17.31 26.58-37.94 4.09-111.27-1.56-129.72-17.06-55.6-57.78-123.44-84.34-115-27.57 8.78-28.59 94.09-19.38 148.03Z"
        />
        {children}
      </g>
    </svg>
  );
}
